module.exports = __webpack_public_path__ + "static/img/zise.a35a4fa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/zise.png
// module id = QKqD
// module chunks = 1